/**
 * 通用表单验证函数
 * @param  {String} value  需要校验的内容
 * @param  {Object} rule 当前input规则
 * @return {Boolean}      验证成功返回true 验证失败返回false
 */
export function formRules(value, rule, item, form) {
   
    let idTypes = ['newcredno','crednumber', 'credno']
    let phoneTypes = ['phone', 'newphone', 'newtel']
    let isRulesId =false
    if (form.credtype == '身份证' || form.newcredtype == '身份证') {
        isRulesId = true
    }
    if (idTypes.indexOf(item.paramsName) != -1 && value != "" && isRulesId) {
        var format = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
        if (!format.test(value)) {
            rule.message = '身份证格式不正确'
            return false
        }else{
            return true
        }
    }else if (phoneTypes.indexOf(item.paramsName) != -1 && value != "") {
        var format = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!format.test(value)) {
            rule.message = '手机号格式不正确'
            return false
        }else{
            return true
        }
    }else{
        return true
    }


}

export function getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')  //构造一个含有目标参数的正则表达式对象
    var r = window.decodeURI(window.location.href).split("?")[1].match(reg)  //匹配目标参数
    if (r != null) { return unescape(r[2]) }
    return null   //返回参数
}

//判断是否为空
export function isNull(value) {
    if (value == undefined || value == "undefined" || value === "" || value == "null" || value == "NULL") {
        return true;
    }
    return false;
}

//判断是否微信浏览器
export function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        // 兼容支付宝
        if (ua.match(/alipayclient/i) == "alipayclient") {
            return true;
        }
        return false;
    }
}

// 判断是否支付宝
export function isAlipay() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/alipayclient/i) == "alipayclient") {
        return true;
    }
    return false;
}

//----------获取url参数值-----------
export function getQueryString(name) {
    //普通的参数
    var queryResult = location.search.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
    //location的参数
    var locationResult = location.href.substr(location.href.lastIndexOf("#/")).match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
    //优先使用location的参数
    if (locationResult != null && locationResult.length > 0) {
        return locationResult[1];
    }
    if (queryResult != null && queryResult.length > 0) {
        return queryResult[1];
    }
    return "";
}

//----------获取url参数值-----------
export function getQueryToken() {
    var token = getQueryString("token");
    if (token != undefined && token != "") {
        localStorage.token = token;
    }
    return token
}

//----------获取url参数值-----------
export function getQueryParams(paramName) {
    var param = getQueryString(paramName);
    console.log(param)
    if (!isNull(param)) {
        localStorage[paramName] = param;
    }
}

//----------获取APP基本参数-----------
export function getBaseParams() {
    getQueryParams("token");
    getQueryParams("openId");
    getQueryParams("waterCorpId");
    getQueryParams("usermobile1");
    getQueryParams("waterCorpName");
    getQueryParams("version");
    if (isWeiXin()) {
        getQueryParams("token" + localStorage.waterCorpId);
        getQueryParams("openId" + localStorage.waterCorpId);
        getQueryParams("usermobile1" + localStorage.waterCorpId);
    }
    getIpurl();
}

//-----判断手机号--------
export function telCheck(mobile) {
    var myreg = /^1[3456789]\d{9}$/;
    if (!myreg.test(mobile)) {
        return false;
    }
    return true;
}

//验证电话，包括固话和手机号
export function checkTelphone(number) {
    return /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(number);
}

//邮箱验证
function emailCheck(r) {
    var pattern = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
    if (!pattern.test(r)) {
        return false;
    }
    else {
        return true;
    }
}

//判断邮编
function postCodeCheck(number) {
    var re = /^[0-9][0-9]{5}$/;
    if (!re.test(number)) {
        return false;
    } else {
        return true;
    }
}

// ----------去除连接符----------
function delLinkMark(str) {
    return str.replace(/-/g, "");
}

// ----------格式化日期----------
function formatDate(num) {
    if (parseInt(num) < 10) {
        return "0" + num;
    } else {
        return num;
    }
}

//----------调试log--------
function log(str) {
    console.log(str);
}

//----------取消冒泡--------
function stopProp(e) {
    if (e.stopPropagation)
        e.stopPropagation();
    else
        e.cancelBubble = true;
}

//-----------刷新本页面----------
function refresh() {
    document.location.reload();
}

//-----------数字验证----------
export function isNumber(str) {
    var retel = /^[\d]+$/;
    if (retel.test(str) || str == "") {
        return true;
    } else {
        return false;
    }
}

// 去除数组空元素
function ClearNullArr(arr) {
    var len = arr.length;
    for (var i = 0; i < len; i++) {
        if (!arr[i] || arr[i] == '' || arr[i] == undefined) {
            arr.splice(i, 1);
            len--;
            i--;
        }
    }
    return arr;
}

// 去除数组重复元素
function uniqueArr(arr) {
    var result = [], hash = {};
    for (var i = 0, elem; (elem = arr[i]) != null; i++) {
        if (!hash[elem]) {
            result.push(elem);
            hash[elem] = true;
        }
    }
    return result;
}

//app下载
export function downApp() {
    window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.iwater";
}

//-------------创建key（localstorage）----------
export function setLocVal(key, value) {
    window.localStorage[key] = value;
}

//-------------获取key（localstorage）----------
export function getLocVal(key) {
    if (window.localStorage[key])
        return window.localStorage[key];
    else
        return "";
}

//-------------获取key（localstorage）----------
function clearLocVal(key) {
    if (key)
        window.localStorage.removeItem(key);
    else
        window.localStorage.clear();
}

/*是否含数字*/
function hasNum(str) {
    reg = /[0-9]/g;
    return reg.test(str)
}

//是否是字符串
export function IsString(str) {
    return (typeof str == "string" || str.constructor == String);
}

//是否含市、州或县或区、乡或镇或街或路或道、村或组或号或室，港澳台除外
function checkAddress(str) {
    var result = str.match(/市|州|县|区|乡|镇|街|路|道|村|组|号|室|港|澳|台/);
    if (result == null)
        return true;
    return false;
}

//获取当前日期
function getNowDay() {
    var d = new Date();
    var str1 = d.getFullYear()
    var str2 = d.getMonth() + 1;
    var str3 = d.getDate();
    if (str2 < 10) {
        str2 = '0' + str2;
    }
    return str1 + '-' + str2 + '-' + str3;
}

//获取当前时间
function getNowTime() {
    var d = new Date();
    var str1 = d.getHours();
    var str2 = d.getMinutes();
    var str3 = d.getSeconds();
    str1 = parseInt(str1)
    str2 = parseInt(str2)
    str3 = parseInt(str3)
    if (str1 < 10) {
        str1 = '0' + str1;
    }
    if (str2 < 10) {
        str2 = '0' + str2;
    }
    if (str3 < 10) {
        str3 = '0' + str3;
    }
    return str1 + ':' + str2 + ':' + str3;
}

// 取随机数
function RndNum(MaxNum, MinNum) {
    return parseInt((MaxNum - MinNum + 1) * Math.random() + MinNum)
}

//-----清空对应输入框--------------
function clearInput(id) {
    document.getElementById(id).value = "";
}

export function getSystem() {
    if (isAndroid == true) {
        return "Android"
    } else if (isIos == true) {
        return "iOS"
    } else {
        return "unknow"
    }
}


//-----是否是anroid系统--------------
export var isAndroid = (window.navigator.userAgent.indexOf('Android') >= 0 || window.navigator.userAgent.indexOf('Adr') > -1) ? true : false;
//-----是否是ios系统--------------
export var isIos = (window.navigator.userAgent.indexOf('iPhone') >= 0) ? true : false;

//加“1”
function addone(id) {
    document.getElementById(id).value++;
}

//减“1”
function removeone(id) {
    if (document.getElementById(id).value > 1)
        document.getElementById(id).value--;
}

// 计算两个数字的差
export function Subtr(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    //last modify by deeka
    //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(2);
}

//-----是否是anroid系统--------------
var isAndroid = (window.navigator.userAgent.indexOf('Android') >= 0) ? true : false;

// ----------返回上一页----------
export function back() {
    window.history.go(-1);
}

// ----------打开连接----------
export function openHref(str) {
    window.location.href = str;
}

// ------------获取服务器--------------
export function getIpurl() {
    //直接调用原生方法获取BaseUrl
    var url;
    try {
        url = window.obj.getBaseUrl();
    } catch (e) {
        console.log(e)
        url = ""
    }
    //如果BaseUrl不为空，更新localStorage中的ip_url
    if (url != undefined && url != '' || isWeiXin()) {
        localStorage.ip_url = url;
    }
    if (isNull(localStorage.ip_url)) {
        return "";
    }
    return localStorage.ip_url;
}

// 根据时间戳格式化日期
function add0(m) {
    return m < 10 ? '0' + m : m
}

export function formatDateMonth(stortime) {
    if (stortime == undefined) {
        return "0000/00";
    } else {
        var time = new Date(stortime);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        return y + '/' + add0(m);
    }
}

// export function formatDate(stortime) {
//     if (stortime == undefined) {
//         return "0000-00-00";
//     } else {
//         var time = new Date(stortime);
//         var y = time.getFullYear();
//         var m = time.getMonth() + 1;
//         var d = time.getDate();
//         return y + '-' + add0(m) + '-' + add0(d);
//     }
// }

export function formatDateTime(stortime) {
    if (stortime == undefined) {
        return "0000-00-00";
    } else {
        var time = new Date(stortime);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var min = time.getMinutes();
        var s = time.getSeconds();
        return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(min) + ':' + add0(s);
    }
}

export function subTime(endTime) {
    var date1 = new Date();  //开始时间
    var date3 = date1.getTime() - endTime;//时间差的毫秒数
    //计算出相差天数
    var days = Math.floor(date3 / (24 * 3600 * 1000))
    //计算出小时数
    var leave1 = date3 % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)      //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)        //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)
    return days != 0 ? days + "天前" : hours != 0 ? hours + "小时前" : minutes != 0 ? minutes + "分钟前" : seconds != 0 ? seconds + "秒前" : "0秒前"
}

/**
 * 校验整数输入
 * @param event
 * @param input
 */
export function handleIntChange(event, input) {
    event = window.event || event;
    if (event.keyCode == 37 | event.keyCode == 39) {
        return;
    }
    if (input.value.substring(0, 1) == '0') {
        if (input.value.substring(1, 2) != '.') {
            input.value = 0;
        }
    }
    //先把非数字的都替换掉，除了数字和.
    var value = input.value.replace(/[^\d]/g, "")//只允许一个小数点
    if (value >= 100000) {
        return input.value = 100000;
    }
    if (input.value != value) {
        return input.value = (value);
    } else {
        return input.value;
    }
}

/**
 * 校验输入
 * @param event
 * @param input
 */
export function handleChange(event, input) {
    event = window.event || event;
    if (event.keyCode == 37 | event.keyCode == 39) {
        return;
    }
    if (input.value.substring(0, 1) == '0') {
        if (input.value.substring(1, 2) != '.') {
            input.value = 0;
        }
    }
    //先把非数字的都替换掉，除了数字和.
    var value = input.value.replace(/[^\d.]/g, "").//只允许一个小数点
        replace(/^\./g, "").replace(/\.{2,}/g, ".").//只能输入小数点后两位
        replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    if (value >= 100000) {
        return input.value = 100000;
    }
    if (input.value != value) {
        return input.value = (value);
    } else {
        return input.value;
    }
}

/**
 * 移除小数点
 * @param input
 */
export function handleBlurChange(input) {
    //最后一位是小数点的话，移除
    input.value = ((input.value.replace(/\.$/g, "")));
}

/**
 * 防止二次点击
 * @param milliseconds
 */
export function throttleFirst(dom, click, milliseconds = 1000) {
    let canClick = true;
    dom.addEventListener("click", function () {
        if (canClick) {
            canClick = false;
            // try {
            click();
            // } catch (e) {
            //     console.log(e);
            // }
            setTimeout(function () {
                canClick = true;
            }, milliseconds)
        }
    }, false);
}

/**
 * 跳转原生页面
 * android：
 *  1：不是html：androidAction=“com.iwater.activity”;androidParams={a:"b"}
 *  2：是html：androidAction=“http://aa.html”;androidParams=""
 * ios:
 *  1:不是html，iosAction=“aController”;iosParams={a:"b"}
 *  2:是本地html，iosAction=“aController”;iosParams={htmlType:2,htmlPath:'html/commercial.html?id='+$(this).attr('data-id')};
 *  2:是服务器html，iosAction=“aController”;iosParams={url:"http://xxxxx"};
 *
 *  ！iosAction和androidAction 在有些json中的体现为iosUrl 和 androidUrl
 *
 */
export const forWordPage = (androidAction, androidParams, iosAction, iosParams) => {
    if (isAndroid == true) {
        if (androidAction.indexOf('http://') == -1) {
            //如果不是html，则是原生页面
            if (androidParams == 'undefined' || androidParams == "") {
                androidParams = {};
            }
            window.obj.forwardPage(androidAction, JSON.stringify(androidParams));
        } else {
            //如果是html 也是调用原生页面 但是是有默认顶部导航栏？
            var paramJson = { url: androidAction };
            window.obj.forwardPage('com.iwater.watercorp.main.GlobalWebViewActivity', JSON.stringify(paramJson));
        }
    } else {
        if (iosParams == 'undefined' || iosParams == "") {
            iosParams = {};
        }
        window.obj.forwardPage(iosAction, JSON.stringify(iosParams));
    }
}

/**
 * 脱敏
 * @param str
 * @return {string}
 */
export function desensitization(str) {
    return new Array(str.length).join('*') + str.substr(-1);
}

/**
 * 计算金额累加
 * @param a
 * @param b
 * @return {number}
 */
export function sumMoney(a, b) {
    return accAdd(a, b).toFixed(2)
}

/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：accAdd(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
function accAdd(arg1, arg2) {
    var r1, r2, m, c;
    try {
        r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
        r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
        var cm = Math.pow(10, c);
        if (r1 > r2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
        } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
        }
    } else {
        arg1 = Number(arg1.toString().replace(".", ""));
        arg2 = Number(arg2.toString().replace(".", ""));
    }
    return (arg1 + arg2) / m;
}

/**
 * 校验身份证
 * @param ID
 * @return {boolean}
 */
export function checkCreNo(ID) {
    if (typeof ID !== 'string') return false;
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    if (reg.test(ID) === false) {
        return false;
    }
    return checkID(ID);
}

export const checkID = (str) => {
    if (isNull(str) || str.length != 18) {
        return false
    }
    let weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    let checkArr = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
    let checkArr2 = [1, 0, 'x', 9, 8, 7, 6, 5, 4, 3, 2]
    let sum = 0
    let Y
    for (let i = 0; i <= 16; i++) {
        sum += str[i] * weight[i]
    }
    Y = sum % 11
    if (str[17] == checkArr[Y] || str[17] == checkArr2[Y]) {
        return true
    } else {
        return false
    }
}